'use strict';

const platformUtils = require('santa-platform-utils');

module.exports = {
  getApi: function(routersMap, appStorage) {
    return {
      links: {
        toUrl: platformUtils.linkUtils.convertLinkObjectToUrl.bind(platformUtils.linkUtils, routersMap)
      },
      storage: appStorage
    };
  }
};



// WEBPACK FOOTER //
// ./src/main/platformUtilities/platformUtilities.js